module.exports = __webpack_public_path__ + "static/media/kia-checkmark.71767bf4.svg";